module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C63"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C71"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgments#page_ix"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C72"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Author_s_Notes#page_xv"
    }
  }, [_vm._v("Author’s Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#page_1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__Sex_in_Gray_Spaces#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Sex in Gray Spaces")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_2__First_Timers_Welcome#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. First-Timers Welcome!")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Stigma_and_the_Moral_Economy#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Stigma and the Moral Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Healing_Customers#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Healing Customers")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_5__Victims_All#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Victims All")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_6__Risk_and_Rights#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Risk and Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "C72"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Epilogue#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Glossary#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Bibliography#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "C71"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Index#page_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0